import React from "react";
//#region types
import { QuotationCreateProps } from "models/propTypes/quotationPropTypes";
import { TranslationKeys } from "translations";
import { HTMLConstants } from "utils/constants";
//#endregion
//#region components
import { PageLayouts, ViewPanel, SimpleEntityTitle, Skeletons } from "components/common";
import QuotationFormContainer from "./forms/quotationFormContainer";
import { Grid } from "@mui/material";
//#endregion
import { InvoiceHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const CreateQuotation: React.FC<QuotationCreateProps> = (props) => {
  const { loading, quotation } = props;

  const upperLeftComponent = React.useMemo(
    () => (
      <SimpleEntityTitle
        title={
          quotation && quotation.serialNumber
            ? `${LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.Quotation.Quotation
              )} ${InvoiceHelper.formatInvoiceNumber(quotation.serialNumber)}`
            : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Quotation.NewQuotation)
        }
      />
    ),
    [quotation]
  );

  const upperRightComponent = React.useMemo(
    () =>
      loading ? (
        <></>
      ) : (
        <Grid item container justifyContent="space-between" direction="row" alignItems="center">
          <Grid item id={HTMLConstants.WizardQuickSelectionPortalId}></Grid>
        </Grid>
      ),
    [loading, props.quotation?.serialNumber]
  );

  return (
    <PageLayouts.EntityCreationLayout
      className={cssExports.invoiceCreationWizard}
      upperLeftComponent={upperLeftComponent}
      upperRightComponent={upperRightComponent}
      lowerLeftComponent={<></>}
    >
      {loading ? (
        <ViewPanel>
          <Skeletons.FormSkeleton />
        </ViewPanel>
      ) : (
        <ViewPanel className={cssExports.wizardOuter}>
          <QuotationFormContainer quotation={quotation} />
        </ViewPanel>
      )}
    </PageLayouts.EntityCreationLayout>
  );
};

export default CreateQuotation;
